export default "__VITE_ASSET__BRFoZvyv__"